import { useState, useCallback } from 'react';

export function useToggle(init: boolean = false) {
  const [val, setVal] = useState(init);
  const toggle = useCallback(() => setVal((v) => !v), []);
  return [val, toggle] as const;
}
